export type SectorCard = {
  slug: string;
  title: string;
  subcategories: string[];
  /** Placeholder sector — shown in grid but not selectable for discover search. */
  comingSoon?: boolean;
};

export const HOME_SECTOR_CARDS: SectorCard[] = [
  {
    slug: "energy-utilities",
    title: "Energy & Utilities",
    subcategories: ["Oil & Gas", "Power & Energy (Conventional & Renewables)"],
  },
  {
    slug: "industrial-manufacturing",
    title: "Industrial & Manufacturing",
    subcategories: [
      "Manufacturing & Industrial Automation",
      "Chemicals & Specialty Materials",
      "Metals & Minerals",
    ],
  },
  {
    slug: "mobility-aerospace-defence",
    title: "Mobility, Aerospace & Defence",
    subcategories: ["Automotive & EV Ecosystem", "Defence & Aerospace", "Shipping, Maritime & Ports"],
  },
  {
    slug: "infrastructure-built-environment",
    title: "Infrastructure & Built Environment",
    subcategories: ["Construction", "Infrastructure & EPC"],
  },
  {
    slug: "technology-electronics",
    title: "Technology & Electronics",
    subcategories: ["ICT", "Software, API & Digital Technologies", "Electronics & Semiconductors"],
  },
  {
    slug: "environment-sustainability",
    title: "Environment & Sustainability",
    subcategories: [
      "Water & Wastewater",
      "Environmental Solutions",
      "Climate Tech, Carbon Management & Sustainability Solutions",
    ],
  },
  {
    slug: "agriculture-food-systems",
    title: "Agriculture & Food Systems",
    subcategories: ["Agriculture, Agritech & Food Processing"],
  },
  {
    slug: "healthcare-life-sciences",
    title: "Healthcare & Life Sciences",
    subcategories: ["Healthcare", "MedTech & Life Sciences"],
  },
  {
    slug: "automotive-manufacturing-mobility-ecosystem",
    title: "Automotive Manufacturing & Mobility Ecosystem",
    subcategories: [],
    comingSoon: true,
  },
  {
    slug: "global-fmcg-supply-chain-distribution-ecosystem",
    title: "Global FMCG Supply Chain & Distribution Ecosystem",
    subcategories: [],
    comingSoon: true,
  },
];

export function getSectorBySlug(slug: string | undefined): SectorCard | null {
  if (!slug) return null;
  return HOME_SECTOR_CARDS.find((sector) => sector.slug === slug) ?? null;
}
